exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-mask[data-v-5444e201]{position:fixed;top:0;left:0;z-index:900;width:100vw;height:100vh;background:rgba(0,0,0,.3);display:grid;place-items:center}.modal-placeholder[data-v-5444e201]{background-color:#fff;border-radius:1rem;position:relative;padding-bottom:10px}.modal-header[data-v-5444e201]{text-align:left;position:relative;border-bottom:1px solid #eee;color:#eee;justify-content:space-between;background-color:#4baf4d;border-radius:1rem 1rem 0 0}.modal-fade-enter-from[data-v-5444e201],.modal-fade-leave-to[data-v-5444e201]{opacity:0}.modal-fade-enter-active[data-v-5444e201],.modal-fade-leave-active[data-v-5444e201]{transition:all .25s ease}.inner[data-v-5444e201]{position:relative;padding:15px;overflow:auto;display:flex;max-height:950px;max-width:950px}[data-v-5444e201]{margin:0;padding:0;box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5444e201&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modal/ModalFactory.vue
// module id = 889
// module chunks = 2